export const setDashboardConfig = (data) => ({
  type: "SET_DASHBOARD_CONFIG",
  payload: data,
});